import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import ModalBox from '../../../shared/modal';

import classname from 'classname';
import {Field} from 'redux-form';
import selectField from '../../../shared/form-elements/select';

lessRequire('modules/offers/components/popups/rules.less');

const DownloadPopup = props => {
	const className = classname({
		'ReactModal__Content': true,
		'ReactModal__Content--after-open': true,
		'modal-overlay__content': true,
		'rules-modal': true
	});

	return (
		<ModalBox
			body={ModalBody(props)}
			isOpen={props.isOpen}
			onClose={props.togglePopup}
			title={`${props.intl('Предупреждение')}`}
			className={className}
		/>
	);
};

DownloadPopup.propTypes = {
	shouldShowRules: PropTypes.bool,
	isEditMode: PropTypes.bool,
	selectedOffer: PropTypes.object,
	toggleRulesPopup: PropTypes.func,
	intl: PropTypes.func,
	href: PropTypes.string
};

const ModalBody = (props) => {

	function openHref() {
		window.open(`${props.requestUrl}${props.isPhpPopup ? '&is_php=true' : ''}`, '_blank');
	}
	const isNeedSelectLocation = props.possibleLocations.length > 1;

	return (
		<div className="rules-body">
			<br />
			<br />
			{!props.isEditMode &&
				<div className="rule-wrap">
					{props.intl('Нужно сохранить поток')}
				</div>
			}
			{isNeedSelectLocation &&
				<div className="rule-wrap">
					<br />
					<br />
					{props.intl('Выберите гео для лендинга:')}
					<br />
					<Field name="download_location"
						placeholder={props.intl('Выберите страну для лендинга')}
						component={selectField}
						options={props.possibleLocations}
						onChange={e => { props.setLandingTargeting(e.value);}}
					/>
				</div>
			}
			<br />
			<br />
			<div className="control-btn">

				{
					!isNeedSelectLocation &&
					<input
						id={'ok_button'}
						type="button" form="streamForm"
						className="button yellow-btn font-proxima-nova-semibold"
						onClick={props.togglePopup}
						value={props.intl('OK')}
					/>
				}

				<input
					id={'download_anyway'}
					type="button" form="streamForm"
					className={classname({
						'button': true,
						'cancel': !props.landingTargeting,
						'font-proxima-nova-semibold': true,
						'yellow-btn': !!props.landingTargeting
					})}
					onClick={openHref}
					value={props.intl('Скачать')}
				/>

				{
					isNeedSelectLocation &&
					<input
						id={'cancel_button'}
						type="button" form="streamForm"
						className="button yellow-btn font-proxima-nova-semibold"
						onClick={props.togglePopup}
						value={props.intl('Отмена')}
					/>
				}
			</div>
		</div>
	);
};

ModalBody.propTypes = {
	intl: PropTypes.func,
	selectedOffer: PropTypes.object
};

export default DownloadPopup;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/popups/download-popup.js